import { ReactCta } from '@/components/react/ui/ReactCta';
import { Dialog } from '@base-ui-components/react/dialog';
import type { ComponentProps, ReactElement, ReactNode } from 'react';

interface ReactModalTriggerProps {
  children: ReactNode;
  className?: string;
  cta?: ComponentProps<typeof ReactCta>;
  customTrigger?: ReactElement;
}

export const ReactModalTriggerCta = ({
  children,
  className,
  cta,
  customTrigger,
  ...props
}: ReactModalTriggerProps) => {
  if (!cta && !customTrigger) {
    return null;
  }

  const Trigger = customTrigger || <ReactCta {...cta} />;

  return (
    <Dialog.Root {...props}>
      <Dialog.Trigger className={className || ''} render={Trigger} />
      {children}
    </Dialog.Root>
  );
};
